import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue";
const _hoisted_1 = {
  class: "demoEditorLock"
};
const _hoisted_2 = {
  key: 0,
  class: "demoCard"
};
const _hoisted_3 = {
  key: 0,
  class: "demoThumb"
};
const _hoisted_4 = ["src", "alt"];
const _hoisted_5 = {
  key: 1,
  class: "demoIconWrap"
};
const _hoisted_6 = {
  class: "demoTitle"
};
const _hoisted_7 = {
  key: 2,
  class: "demoDescription"
};
const _hoisted_8 = {
  class: "demoSubtitle"
};
const _hoisted_9 = {
  key: 3,
  class: "demoProgressMeta"
};
const _hoisted_10 = {
  key: 4,
  class: "demoProgress"
};
const _hoisted_11 = {
  key: 5,
  class: "demoGenMessage"
};
const _hoisted_12 = {
  key: 6,
  class: "demoWaitHint"
};
const _hoisted_13 = {
  key: 7,
  class: "demoPublishedHint"
};
const _hoisted_14 = {
  class: "demoActions"
};
const _hoisted_15 = {
  key: 1,
  class: "demoCard demoSuccess"
};
const _hoisted_16 = {
  class: "demoIconWrap success"
};
const _hoisted_17 = {
  class: "demoTitle"
};
const _hoisted_18 = {
  class: "demoSubtitle"
};
const _hoisted_19 = {
  key: 0,
  class: "demoShare"
};
const _hoisted_20 = {
  class: "demoShareLabel"
};
const _hoisted_21 = {
  class: "demoShareRow"
};
const _hoisted_22 = {
  class: "demoActions"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_icon = _resolveComponent("icon");
  const _component_el_progress = _resolveComponent("el-progress");
  const _component_el_button = _resolveComponent("el-button");
  const _component_el_input = _resolveComponent("el-input");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [!_ctx.published ? (_openBlock(), _createElementBlock("div", _hoisted_2, [_ctx.thumbnailUrl ? (_openBlock(), _createElementBlock("div", _hoisted_3, [_createElementVNode("img", {
    src: _ctx.thumbnailUrl,
    alt: _ctx.speachTitle,
    class: "demoThumbImg"
  }, null, 8, _hoisted_4)])) : (_openBlock(), _createElementBlock("div", _hoisted_5, [_createVNode(_component_icon, {
    icon: "creation-outline",
    size: "huge",
    color: "primary"
  })])), _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.speachTitle || _ctx.$t('demoEditor.title')), 1), _ctx.speachDescription ? (_openBlock(), _createElementBlock("div", _hoisted_7, _toDisplayString(_ctx.speachDescription), 1)) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_8, _toDisplayString(_ctx.alreadyPublished ? _ctx.$t('demoEditor.alreadyPublished') : _ctx.publishable ? _ctx.$t('demoEditor.ready') : _ctx.$t('demoEditor.generating')), 1), !_ctx.alreadyPublished && _ctx.totalSubchapters > 0 ? (_openBlock(), _createElementBlock("div", _hoisted_9, _toDisplayString(_ctx.$t('demoEditor.progressLabel', {
    done: _ctx.validSubchapters,
    total: _ctx.totalSubchapters
  })), 1)) : _createCommentVNode("", true), !_ctx.alreadyPublished ? (_openBlock(), _createElementBlock("div", _hoisted_10, [_createVNode(_component_el_progress, {
    class: "demoProgressBar",
    indeterminate: true,
    percentage: _ctx.percent,
    "stroke-width": 14,
    duration: 1
  }, null, 8, ["percentage"])])) : _createCommentVNode("", true), !_ctx.alreadyPublished && !_ctx.publishable && _ctx.currentMessage ? (_openBlock(), _createElementBlock("div", _hoisted_11, _toDisplayString(_ctx.currentMessage), 1)) : _createCommentVNode("", true), !_ctx.alreadyPublished && !_ctx.publishable ? (_openBlock(), _createElementBlock("div", _hoisted_12, _toDisplayString(_ctx.$t('demoEditor.waitHint')), 1)) : _createCommentVNode("", true), _ctx.alreadyPublished ? (_openBlock(), _createElementBlock("div", _hoisted_13, _toDisplayString(_ctx.$t('demoEditor.playHint')), 1)) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_14, [_ctx.alreadyPublished ? (_openBlock(), _createBlock(_component_el_button, {
    key: 0,
    class: "demoPlayButton",
    size: "large",
    round: "",
    onClick: _ctx.play
  }, {
    default: _withCtx(() => [_createVNode(_component_icon, {
      icon: "play",
      class: "demoBtnIcon"
    }), _createTextVNode(" " + _toDisplayString(_ctx.$t('demoEditor.playButton')), 1)]),
    _: 1
  }, 8, ["onClick"])) : (_openBlock(), _createBlock(_component_el_button, {
    key: 1,
    type: "primary",
    size: "large",
    round: "",
    disabled: !_ctx.publishable,
    loading: _ctx.publishing,
    onClick: _ctx.publish
  }, {
    default: _withCtx(() => [_createVNode(_component_icon, {
      icon: "play",
      class: "demoBtnIcon"
    }), _createTextVNode(" " + _toDisplayString(_ctx.$t('demoEditor.watch')), 1)]),
    _: 1
  }, 8, ["disabled", "loading", "onClick"]))])])) : (_openBlock(), _createElementBlock("div", _hoisted_15, [_createElementVNode("div", _hoisted_16, [_createVNode(_component_icon, {
    icon: "check-circle-outline",
    size: "huge",
    color: "success"
  })]), _createElementVNode("div", _hoisted_17, _toDisplayString(_ctx.$t('demoEditor.publishedTitle')), 1), _createElementVNode("div", _hoisted_18, _toDisplayString(_ctx.$t('demoEditor.publishedSubtitle')), 1), _ctx.shareUrl ? (_openBlock(), _createElementBlock("div", _hoisted_19, [_createElementVNode("div", _hoisted_20, _toDisplayString(_ctx.$t('demoEditor.share')), 1), _createElementVNode("div", _hoisted_21, [_createVNode(_component_el_input, {
    "model-value": _ctx.shareUrl,
    readonly: ""
  }, null, 8, ["model-value"]), _createVNode(_component_el_button, {
    onClick: _ctx.copyShareUrl
  }, {
    default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('demoEditor.copy')), 1)]),
    _: 1
  }, 8, ["onClick"])])])) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_22, [_createVNode(_component_el_button, {
    type: "primary",
    size: "large",
    round: "",
    onClick: _ctx.createAnother
  }, {
    default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('demoEditor.createAnother')), 1)]),
    _: 1
  }, 8, ["onClick"])])]))]);
}